import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String }
    static targets = ["output", "form"]

    filter(event) {
        event.preventDefault()

        const data = new FormData()
        this.formTarget.querySelectorAll("input, select, textarea").forEach((field) => {
            if (field.name) data.append(field.name, field.value)
        })
        const el = this.outputTarget

        fetch(this.urlValue, { headers: this.headers, method: "POST", body: data }).then((response) => response.text()).then(function (data) { el.innerHTML = data; });
    }

    get headers() { return { "X-CSRF-Token": this.getMetaValue("csrf-token"), 'X-Requested-With': 'XMLHttpRequest' } }

    getMetaValue(name) {
        const element = document.head.querySelector(`meta[name="${name}"]`);
        if (element) {
            return element.getAttribute("content");
        }
    }
    paginate(event) {
        event.preventDefault()

        const href = event.currentTarget.getAttribute("href")
        const el = this.outputTarget

        fetch(href).then((response) => response.text()).then(function (data) { el.innerHTML = data; });
    }
}